/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.ParticipantsInvites = {

  _disableOrEnableSubmitButton() {
    if (($('#selected-company-colleague-roles :radio:checked').length > 0) &&
       ($('#selected-company-colleague-list tr').length > 0)) {

      return $('.invite-companies-colleagues').removeAttr('disabled');
    } else {
      return $('.invite-companies-colleagues').attr('disabled', 'disabled');
    }
  },

  _filterCompanies(url, query, list_id, list_type){
    return $.ajax({
      url,
      type: 'GET',
      data: { query, list_id, list_type },
      success(data) {
        $('.company-colleague-list').html(data);
        $('.company-colleague-list').scrollTop(0);
        $('.company-colleague-list').data('query', query);
        $('.company-colleague-list').data('currentPage', 2);
        return $(document).foundation('tooltip', 'reflow');
      }
    });
  },

  _addSpinner($elem) {
    const spinner = '<div class="spinner spinner-invites spinner-center dark"></div>';
    return $elem.append(spinner);
  },

  _removeSpinner() {
    return $('.spinner-invites').remove();
  },

  _getMoreCompaniesAtBottom(e){
    const $scroll = $(e.target);
    const $list = $('.company-colleague-list');
    const activeFilter = $('#companies-filter-drop').parent().find('span').text();
    if ((activeFilter === I18n.t('v4.participants.companies.index.all')) && (($scroll[0].scrollHeight - $scroll.scrollTop()) <= $scroll.outerHeight())) {
      ParticipantsInvites._addSpinner($list);
      if ($list.data('currentPage') === undefined) {
        $list.data('currentPage', 2);
      }
      return $.ajax({
        url: $('#query').data('url'),
        type: 'GET',
        data: {
          page: $list.data('currentPage'),
          query: $list.data('query'),
          list_id: 'all'
        },
        success(data) {
          $('.company-colleague-list').data('currentPage', $list.data('currentPage') + 1);
          $('.company-colleague-list').append(data);
          return ParticipantsInvites._removeSpinner();
        }
      });
    }
  },

  _initializeScroll() {
    return $('.company-colleague-scroll').bind('scroll', this._getMoreCompaniesAtBottom);
  },

  _initializeSelectAction() {
    const _self = this;
    $(document).on('click', '.select-company-colleague', function() {
      if ($(`#selectedCompaniesColleagues${$(this).data('id')}`).length === 0) {
        $("#selected-company-colleague-list").append(_self.invitable.selectedTemplate({name: $(this).data('name'), id: $(this).data('id')}));
      }
      $(`#company-colleague-${$(this).data('id')}`).hide();
      return _self._disableOrEnableSubmitButton();
    });

    $(document).on('click', '.remove-company-colleague', function(e) {
      e.preventDefault();
      $(`#selectedCompaniesColleagues${$(this).data('id')}`).remove();
      $(`#company-colleague-${$(this).data('id')}`).show();
      return _self._disableOrEnableSubmitButton();
    });

    return $(document).on('click', '#selected-company-colleague-roles :radio', () => _self._disableOrEnableSubmitButton());
  },

  _initializeQueryFilter() {
    const _self = this;
    let typingTimer = undefined;
    return $(document).on('keyup', '#query', function() {
      clearTimeout(typingTimer);
      const query = $(this).val();
      const url = $(this).data('url');
      const list_id = $('.companies-filter.selected').data('listId');
      const list_type = $('.companies-filter.selected').data('listType');
      return typingTimer = setTimeout(() => {
        return _self._filterCompanies(url, query, list_id, list_type);
      }
      , 500);
    });
  },

  _showOnDropDown(target){
    target.parents('ul').find('a').removeClass('selected');
    target.addClass('selected');
    return target.parents('ul').parent().find('span').text(target.text());
  },

  _initializeDropdownFilter() {
    return $(document).on('click', '.companies-filter', e => {
      e.preventDefault();
      const $target = $(e.currentTarget);
      this._showOnDropDown($target);
      return this._filterCompanies(window.location.href, '', $target.data('listId'), $target.data('listType'));
    });
  },

  initializeIndex(invitable){
    this.invitable = invitable;
    this._initializeQueryFilter();
    this._initializeDropdownFilter();
    if (this.invitable.participantType !== 'colleague') {
      this._initializeScroll();
    }
    this._initializeSelectAction();
    return this.invitable.initialize();
  }
};
